module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    staticClass: "ml-2 mr-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.DateTypeFilter ||
        _vm.Filter.ModuleTypeFilter ||
        _vm.Filter.PaymentTypeFilter ||
        _vm.Filter.JobNoFilter ||
        _vm.Filter.TransactionNoFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.TransportTypeFilter ||
        _vm.Filter.ShipemntTypeFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.POLFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.DateTypeFilter ||
    _vm.Filter.ModuleTypeFilter ||
    _vm.Filter.PaymentTypeFilter ||
    _vm.Filter.JobNoFilter ||
    _vm.Filter.TransactionNoFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.TransportTypeFilter ||
    _vm.Filter.ShipemntTypeFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.POLFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.paymentList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getPaymentList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.paymentList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.exportToExcelClient
    }
  }, [_vm._v("\n            Export (Client XLSX)\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Date Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.DateTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "DateTypeFilter", $$v)
      },
      expression: "Filter.DateTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Module Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.moduleOptions,
      "option-value": "Val",
      "option-text": "Text",
      "placeholder": "Select Module Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ModuleTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ModuleTypeFilter", $$v)
      },
      expression: "Filter.ModuleTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Payment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.payTypeOptions,
      "option-value": "Val",
      "option-text": "Text",
      "placeholder": "Select Payment Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PaymentTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PaymentTypeFilter", $$v)
      },
      expression: "Filter.PaymentTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Job NO Filter",
      "id": "JobNoFilter",
      "name": "JobNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.JobNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "JobNoFilter", $$v)
      },
      expression: "Filter.JobNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transaction No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Transaction No Filter",
      "id": "TransactionNoFilter",
      "name": "TransactionNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransactionNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransactionNoFilter", $$v)
      },
      expression: "Filter.TransactionNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransportTypeFilter", $$v)
      },
      expression: "Filter.TransportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ShipemntTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ShipemntTypeFilter", $$v)
      },
      expression: "Filter.ShipemntTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "id": "PORFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PORFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORFilter", $$v)
      },
      expression: "Filter.PORFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "id": "POLFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.POLFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POLFilter", $$v)
      },
      expression: "Filter.POLFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPODList'],
      "id": "PODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODFilter", $$v)
      },
      expression: "Filter.PODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLocationDetailsFinalList'],
      "id": "FPODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.FPODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODFilter", $$v)
      },
      expression: "Filter.FPODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "text",
      "option-text": "value",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getPaymentList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-tabs', {
    staticClass: "mb-2",
    on: {
      "input": _vm.onTabChange
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "All"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Bookmarks"
    }
  })], 1), _vm._v(" "), (_vm.tabIndex === 0 || _vm.tabIndex === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [(_vm.paymentList && _vm.paymentList.length) ? _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-button', {
    staticClass: "p-1 mr-2",
    staticStyle: {
      "font-size": "0.9rem",
      "line-height": "1"
    },
    attrs: {
      "size": "xs",
      "variant": "outline-secondary",
      "title": "Select all on this page"
    },
    on: {
      "click": _vm.selectAllVisible
    }
  }, [_vm._v("Select all\n              ")]), _vm._v(" "), _c('b-button', {
    staticClass: "p-1 mr-2",
    staticStyle: {
      "font-size": "0.9rem",
      "line-height": "1"
    },
    attrs: {
      "size": "xs",
      "variant": "outline-secondary",
      "title": "Deselect all on this page"
    },
    on: {
      "click": _vm.deselectAllVisible
    }
  }, [_vm._v("Deselect all\n              ")]), _vm._v(" "), _c('b-button', {
    staticClass: "p-1 mr-2",
    staticStyle: {
      "font-size": "0.9rem",
      "line-height": "1"
    },
    attrs: {
      "size": "xs",
      "variant": "outline-success",
      "title": ("Mark Completed (" + ((_vm.selectedCheckBoxRows || []).length) + ")")
    },
    on: {
      "click": _vm.openMarkPaidBulk
    }
  }, [_vm._v("Mark Completed\n              ")]), _vm._v(" "), _c('b-button', {
    staticClass: "p-1",
    staticStyle: {
      "font-size": "0.9rem",
      "line-height": "1"
    },
    attrs: {
      "size": "xs",
      "variant": "outline-danger",
      "title": "Clear selection"
    },
    on: {
      "click": function($event) {
        _vm.selectedCheckBoxRows = []
      }
    }
  }, [_vm._v("Clear selection\n              ")])], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.paymentList,
      "fields": _vm.PaymentFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "head(checkbox)",
      fn: function(h) {
        return [_c('b-form-checkbox', {
          attrs: {
            "indeterminate": _vm.isHeaderIndeterminate,
            "checked": _vm.isHeaderChecked,
            "title": "Select/Deselect all on this page"
          },
          on: {
            "change": function($event) {
              _vm.toggleSelectAll($event)
            }
          }
        })]
      }
    }, {
      key: "head(bookmark)",
      fn: function(h) {
        return [_c('span', {
          attrs: {
            "title": "Bookmark"
          }
        }, [_vm._v("Fav")])]
      }
    }, {
      key: "bookmark",
      fn: function(row0) {
        return [_c('b-button', {
          staticClass: "p-1 mr-1",
          staticStyle: {
            "font-size": "0.9rem",
            "line-height": "1"
          },
          attrs: {
            "size": "xs",
            "variant": "outline-warning",
            "title": _vm.isBookmarked(row0.item) ? 'Remove bookmark' : 'Add bookmark'
          },
          on: {
            "click": function($event) {
              _vm.toggleBookmark(row0.item)
            }
          }
        }, [_c('md-icon', {
          staticStyle: {
            "font-size": "16px",
            "color": "#f3a000"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.isBookmarked(row0.item) ? 'star' : 'star_border') + "\n                  ")])], 1)]
      }
    }, {
      key: "checkbox",
      fn: function(row0) {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-button', {
          staticClass: "p-1 mr-1",
          staticStyle: {
            "font-size": "0.9rem",
            "line-height": "1"
          },
          attrs: {
            "size": "xs",
            "variant": "outline-info",
            "title": "Show/Hide details"
          },
          on: {
            "click": function($event) {
              _vm.onToggleDetails(row0)
            }
          }
        }, [_c('md-icon', {
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v("\n                      " + _vm._s(row0.detailsShowing ? "expand_less" : "expand_more") + "\n                    ")])], 1), _vm._v(" "), _c('b-button', {
          staticClass: "p-1 mr-2",
          staticStyle: {
            "font-size": "0.9rem",
            "line-height": "1"
          },
          attrs: {
            "size": "xs",
            "variant": "success",
            "title": "Mark Completed"
          },
          on: {
            "click": function($event) {
              _vm.openMarkPaid(row0.item)
            }
          }
        }, [_c('md-icon', {
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('b-form-checkbox', {
          attrs: {
            "value": {
              isParent: true,
              ApeId: row0.item.TransactionId,
              ModuleId: row0.item.ModuleId,
              JobNo: row0.item.JobNo,
              TransactionNo: row0.item.TransactionNo,
              PaymentType: row0.item.PaymentType,
              IsPaymentDone: row0.item.IsPaymentDone,
              InvPayStatus: row0.item.InvPayStatus,
            }
          },
          model: {
            value: (_vm.selectedCheckBoxRows),
            callback: function($$v) {
              _vm.selectedCheckBoxRows = $$v
            },
            expression: "selectedCheckBoxRows"
          }
        })], 1)]
      }
    }, {
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }, {
      key: "invoiceNumber",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Trans No:")]), _vm._v(" " + _vm._s(row1.item.TransactionNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Request Date:")]), _vm._v(" " + _vm._s(row1.item.CreatedAt)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Request By:")]), _vm._v(" " + _vm._s(row1.item.RequestedBy)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Status:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.IsPaymentDone == 1 ? 'success' : 'warning'
          }
        }, [_vm._v("\n                                  " + _vm._s(row1.item.IsPaymentDone == 1 ? 'Paid' : 'Pending') + "\n                                ")]), _c('br'), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "assign_date": row1.item.JobDate,
            "assign_job_type": row1.item.MJobType,
            "assign_raised_from": 'Raised From: ' + row1.item.JobRaisedFrom,
            "assign_raised_by": 'Raised By: ' + row1.item.raisedBy,
            "fk_all_module_id": row1.item.ModuleId,
            "jb_series": row1.item.JobNo,
            "fk_client_id": '',
            "fk_pod_id": ''
          }
        }) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary &\n                  Documents")]) : _vm._e()]
      }
    }, {
      key: "JobNo",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row1.item.JobNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(row1.item.JobDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Raised By:")]), _vm._v(" " + _vm._s(row1.item.JobRaisedBy)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Branch:")]), _vm._v(" " + _vm._s(row1.item.Branch)), _c('br'), _vm._v(" "), (row1.item.ModuleId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.ModuleId,
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.MJobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.Client,
            "PMC_Sline": row1.item.Sline
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.ModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.ModuleId),
            "JobNo": row1.item.JobNo
          }
        }) : _vm._e()]
      }
    }, {
      key: "ClientName",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Sline Name:")]), _vm._v(" " + _vm._s(row1.item.SlineName)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Client:")]), _vm._v(" " + _vm._s(row1.item.ClientName)), _c('br'), _vm._v(" "), (row1.item.ModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.ModuleId,
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.MJobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.Client,
            "PMC_Sline": row1.item.Sline
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.ModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.ModuleId,
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": row1.item.JobDate,
            "PMC_JOBTYPE": row1.item.MJobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.Client,
            "PMC_Sline": row1.item.Sline
          }
        }) : _vm._e()]
      }
    }, {
      key: "POR",
      fn: function(row1) {
        return [_c('strong', [_vm._v("POR:")]), _vm._v(" " + _vm._s(row1.item.POR)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row1.item.POL)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row1.item.POD)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row1.item.FPOD)), _c('br')]
      }
    }, {
      key: "row-details",
      fn: function(row4) {
        return [_c('b-card', {
          staticStyle: {
            "background": "whiteSmoke"
          }
        }, [_c('b-row', [(row4.item._childrenLoading) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "cols": "12"
          }
        }, [_c('span', [_vm._v("Loading child items...")])]) : _vm._e(), _vm._v(" "), (row4.item.children && row4.item.children.length) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "cols": "12"
          }
        }, [_c('div', {
          staticClass: "table-responsive"
        }, [(row4.item.PaymentType == 2) ? _c('table', {
          staticClass: "table table-sm mb-0"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', {
          staticStyle: {
            "width": "30px"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "indeterminate": _vm.isChildrenIndeterminate(row4.item),
            "checked": _vm.areAllChildrenSelected(row4.item),
            "title": "Select/Deselect all items"
          },
          on: {
            "change": function($event) {
              _vm.toggleSelectAllChildren(row4.item, $event)
            }
          }
        })], 1), _vm._v(" "), _c('th', [_vm._v("Trans No")]), _vm._v(" "), _c('th', [_vm._v("AMT")]), _vm._v(" "), _c('th', [_vm._v("Particular")]), _vm._v(" "), _c('th', [_vm._v("Currency")]), _vm._v(" "), _c('th', [_vm._v("Bill To Customer")]), _vm._v(" "), _c('th', [_vm._v("Selling AMT")]), _vm._v(" "), _c('th', [_vm._v("Pay Mode")]), _vm._v(" "), _c('th', [_vm._v("Pay Ref No")]), _vm._v(" "), _c('th', [_vm._v("Pay Date")]), _vm._v(" "), _c('th', [_vm._v("Pay Amount")]), _vm._v(" "), _c('th', [_vm._v("Pay Status")]), _vm._v(" "), _c('th', [_vm._v("Remarks")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "width": "80px"
          }
        }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((row4.item.children), function(ch, idx) {
          return _c('tr', {
            key: ((ch.id || ch.ape_transaction_no || 'row') + "-" + idx)
          }, [_c('td', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.selectedChildRows),
              expression: "selectedChildRows"
            }],
            attrs: {
              "type": "checkbox",
              "disabled": ch.InvPayStatus == 1
            },
            domProps: {
              "value": _vm.childKey(ch, row4.item, idx),
              "checked": Array.isArray(_vm.selectedChildRows) ? _vm._i(_vm.selectedChildRows, _vm.childKey(ch, row4.item, idx)) > -1 : (_vm.selectedChildRows)
            },
            on: {
              "change": [function($event) {
                var $$a = _vm.selectedChildRows,
                  $$el = $event.target,
                  $$c = $$el.checked ? (true) : (false);
                if (Array.isArray($$a)) {
                  var $$v = _vm.childKey(ch, row4.item, idx),
                    $$i = _vm._i($$a, $$v);
                  if ($$el.checked) {
                    $$i < 0 && (_vm.selectedChildRows = $$a.concat([$$v]))
                  } else {
                    $$i > -1 && (_vm.selectedChildRows = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.selectedChildRows = $$c
                }
              }, function($event) {
                _vm.onChildToggle(row4.item, ch, idx)
              }]
            }
          })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.ape_transaction_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_amt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.ledgermaster_relation && ch.ledgermaster_relation.ledger))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.master_currency_relation && ch.master_currency_relation.currencyCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.sc_category))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.selling_amt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_pay_mode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_pay_ref_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_pay_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_pay_amt))]), _vm._v(" "), _c('td', [_c('b-badge', {
            attrs: {
              "variant": ch.InvPayStatus == 1 ? 'success' : 'warning'
            }
          }, [_vm._v("\n                                  " + _vm._s(ch.InvPayStatus == 1 ? 'Paid' : 'Pending') + "\n                                ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.sc_remark))]), _vm._v(" "), _c('td', [_c('b-button', {
            staticClass: "p-1",
            staticStyle: {
              "font-size": "0.9rem",
              "line-height": "1"
            },
            attrs: {
              "disabled": ch.InvPayStatus == 1,
              "size": "xs",
              "variant": "success",
              "title": "Mark this item as completed"
            },
            on: {
              "click": function($event) {
                _vm.openMarkPaidChild(ch, row4.item, 'singleChild')
              }
            }
          }, [_vm._v("Pay3\n                                ")])], 1)])
        }))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "mt-2 d-flex align-items-center",
          staticStyle: {
            "gap": "8px"
          }
        }, [_c('b-button', {
          staticClass: "p-1",
          staticStyle: {
            "font-size": "0.9rem",
            "line-height": "1"
          },
          attrs: {
            "size": "xs",
            "variant": "primary",
            "disabled": _vm.selectedCountForParent(row4.item) < 2,
            "title": _vm.selectedCountForParent(row4.item) >= 2 ? ("Mark Selected (" + (_vm.selectedCountForParent(row4.item)) + ") as Completed") : 'Select 2 or more items'
          },
          on: {
            "click": function($event) {
              _vm.openMarkPaidBulkChildren(row4.item)
            }
          }
        }, [_vm._v("\n                            Pay1\n                          ")])], 1), _vm._v(" "), (row4.item.PaymentType == 1) ? _c('table', {
          staticClass: "table table-sm mb-0"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', {
          staticStyle: {
            "width": "30px"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "indeterminate": _vm.isChildrenIndeterminate(row4.item),
            "checked": _vm.areAllChildrenSelected(row4.item),
            "title": "Select/Deselect all items"
          },
          on: {
            "change": function($event) {
              _vm.toggleSelectAllChildren(row4.item, $event)
            }
          }
        })], 1), _vm._v(" "), _c('th', [_vm._v("Trans No")]), _vm._v(" "), _c('th', [_vm._v("Inv Date")]), _vm._v(" "), _c('th', [_vm._v("NOE")]), _vm._v(" "), _c('th', [_vm._v("Pay Mode")]), _vm._v(" "), _c('th', [_vm._v("Pay Ref No")]), _vm._v(" "), _c('th', [_vm._v("Pay Date")]), _vm._v(" "), _c('th', [_vm._v("Pay Amount")]), _vm._v(" "), _c('th', [_vm._v("Pay Status")]), _vm._v(" "), _c('th', [_vm._v("Remarks")]), _vm._v(" "), _c('th', [_vm._v("Inv Doc")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "width": "80px"
          }
        }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((row4.item.children), function(ch, idx) {
          return _c('tr', {
            key: ((ch.id || ch.ape_transaction_no || 'row') + "-" + idx)
          }, [_c('td', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.selectedChildRows),
              expression: "selectedChildRows"
            }],
            attrs: {
              "type": "checkbox",
              "disabled": ch.InvPayStatus == 1
            },
            domProps: {
              "value": _vm.childKey(ch, row4.item, idx),
              "checked": Array.isArray(_vm.selectedChildRows) ? _vm._i(_vm.selectedChildRows, _vm.childKey(ch, row4.item, idx)) > -1 : (_vm.selectedChildRows)
            },
            on: {
              "change": function($event) {
                var $$a = _vm.selectedChildRows,
                  $$el = $event.target,
                  $$c = $$el.checked ? (true) : (false);
                if (Array.isArray($$a)) {
                  var $$v = _vm.childKey(ch, row4.item, idx),
                    $$i = _vm._i($$a, $$v);
                  if ($$el.checked) {
                    $$i < 0 && (_vm.selectedChildRows = $$a.concat([$$v]))
                  } else {
                    $$i > -1 && (_vm.selectedChildRows = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.selectedChildRows = $$c
                }
              }
            }
          })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.ape_transaction_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.nature_of_expense_relation && ch.nature_of_expense_relation.nature_name) + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_pay_mode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_pay_ref_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_pay_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.inv_pay_amt))]), _vm._v(" "), _c('td', [_c('b-badge', {
            attrs: {
              "variant": ch.InvPayStatus == 1 ? 'success' : 'warning'
            }
          }, [_vm._v("\n                                  " + _vm._s(ch.InvPayStatus == 1 ? 'Paid' : 'Pending') + "\n                                ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(ch.sc_remark))]), _vm._v(" "), _c('td', [(ch && ch.inv_doc_url) ? _c('div', [_c('b-button', {
            staticStyle: {
              "font-size": "0.675rem"
            },
            attrs: {
              "size": "xs",
              "variant": "warning",
              "href": String(ch.inv_doc_url).startsWith('http') ? ch.inv_doc_url : ("" + _vm.docURL + (ch.inv_doc_url)),
              "target": "_blank",
              "rel": "noopener"
            }
          }, [_vm._v("\n                                    View Doc\n                                  ")])], 1) : _vm._e()]), _vm._v(" "), _c('td', [_c('b-button', {
            staticClass: "p-1",
            staticStyle: {
              "font-size": "0.9rem",
              "line-height": "1"
            },
            attrs: {
              "disabled": ch.InvPayStatus == 1,
              "size": "xs",
              "variant": "success",
              "title": "Mark this item as completed"
            },
            on: {
              "click": function($event) {
                _vm.openMarkPaidChild(ch, row4.item, 'singleChild')
              }
            }
          }, [_vm._v("\n                                  Pay2\n                                ")])], 1)])
        }))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (row4.item.invoiceType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Type:")]), _vm._v(" " + _vm._s(row4.item.invoiceType))])]) : _vm._e(), _vm._v(" "), (row4.item.invoiceCategory) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Category :")]), _vm._v(" " + _vm._s(row4.item.invoiceCategory)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.currency) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Currency :")]), _vm._v(" " + _vm._s(row4.item.currency)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.slineBlNo) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Bl No :")]), _vm._v(" " + _vm._s(row4.item.slineBlNo)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.dueDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Due Date :")]), _vm._v(" " + _vm._s(row4.item.dueDate)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.sobDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Sob Date :")]), _vm._v(" " + _vm._s(row4.item.sobDate)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.paymentCreatedBy) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Created By :")]), _vm._v("\n                        " + _vm._s(row4.item.paymentCreatedBy)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.MJobType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Job Type :")]), _vm._v(_vm._s(row4.item.MJobType)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.JobTransportType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Transport Type:")]), _vm._v(" " + _vm._s(row4.item.JobTransportType))])]) : _vm._e(), _vm._v(" "), (row4.item.JobTContainerType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Container Type:")]), _vm._v(" " + _vm._s(row4.item.JobTContainerType))])]) : _vm._e(), _vm._v(" "), (row4.item.Branch) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row4.item.Branch))])]) : _vm._e(), _vm._v(" "), (row4.item.RaisedBy) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(row4.item.RaisedBy))])]) : _vm._e(), _vm._v(" "), (row4.item.HBL) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("HBL:")]), _vm._v(" " + _vm._s(row4.item.HBL))])]) : _vm._e(), _vm._v(" "), (row4.item.MBL) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("MBL:")]), _vm._v(" " + _vm._s(row4.item.MBL))])]) : _vm._e(), _vm._v(" "), (row4.item.MBLDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("MBL Date:")]), _vm._v(" " + _vm._s(row4.item.MBLDate))])]) : _vm._e(), _vm._v(" "), (row4.item.MBLReleaseDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("MBL Release Date:")]), _vm._v(" " + _vm._s(row4.item.MBLReleaseDate))])]) : _vm._e(), _vm._v(" "), (row4.item.ExpClientName) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Exp Client Name:")]), _vm._v(" " + _vm._s(row4.item.ExpClientName))])]) : _vm._e(), _vm._v(" "), (row4.item.ImpClientName) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Imp Client Name:")]), _vm._v(" " + _vm._s(row4.item.ImpClientName))])]) : _vm._e(), _vm._v(" "), (row4.item.POD) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row4.item.POD))])]) : _vm._e(), _vm._v(" "), (row4.item.FPOD) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row4.item.FPOD))])]) : _vm._e(), _vm._v(" "), (row4.item.Pickup) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("PICK:")]), _vm._v(" " + _vm._s(row4.item.Pickup))])]) : _vm._e(), _vm._v(" "), (row4.item.Stuff) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("STUFF:")]), _vm._v(" " + _vm._s(row4.item.Stuff))])]) : _vm._e(), _vm._v(" "), (row4.item.Handover) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("HAND:")]), _vm._v(" " + _vm._s(row4.item.Handover))])]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('BulkPaymentModal', {
    attrs: {
      "show": _vm.markPaidBulk.show,
      "selectedItems": _vm.getBulkPaymentItems(),
      "payModeOptions": _vm.payModeOptions,
      "isLoading": _vm.isLoading
    },
    on: {
      "close": _vm.closeBulkPaymentModal,
      "submit": _vm.handleBulkPaymentSubmit,
      "error": _vm.handleBulkPaymentError
    }
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "mark-paid-single-modal",
      "title": "Mark Payment as Completed",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": ""
    },
    model: {
      value: (_vm.markPaidSingle.show),
      callback: function($$v) {
        _vm.$set(_vm.markPaidSingle, "show", $$v)
      },
      expression: "markPaidSingle.show"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "text-center p-4"
  }, [_c('b-spinner', {
    attrs: {
      "label": "Loading..."
    }
  })], 1) : _c('div', [(_vm.markPaidSingle.item) ? _c('b-card', {
    staticClass: "mb-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Transaction No:")]), _vm._v(" " + _vm._s(_vm.markPaidSingle.item.TransactionNo || _vm.markPaidSingle.item.transactionNo || '-') + "\n              ")]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(_vm.markPaidSingle.item.JobNo || _vm.markPaidSingle.item.jobNo || '-') + "\n              ")])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Type:")]), _vm._v(" "), _c('b-badge', {
    attrs: {
      "variant": _vm.markPaidSingle.item.PaymentType == 1 ? 'info' : (_vm.markPaidSingle.item.PaymentType == 2 ? 'secondary' : 'light')
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.markPaidSingle.item.PaymentType == 1 ? 'Exp' : (_vm.markPaidSingle.item.PaymentType == 2 ? 'Additional Task' : '-')) + "\n                ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Amount:")]), _vm._v(" " + _vm._s(_vm.markPaidSingle.item.inv_amt || _vm.markPaidSingle.item.selling_amt || '-') + "\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-form', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pay Mode",
      "label-for": "single-pay-mode"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "single-pay-mode",
      "options": _vm.payModeOptions,
      "state": _vm.markPaidSingle.inv_pay_mode ? null : false
    },
    model: {
      value: (_vm.markPaidSingle.inv_pay_mode),
      callback: function($$v) {
        _vm.$set(_vm.markPaidSingle, "inv_pay_mode", $$v)
      },
      expression: "markPaidSingle.inv_pay_mode"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Pay Mode")])])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reference No",
      "label-for": "single-ref-no"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "single-ref-no",
      "placeholder": "Reference No",
      "state": _vm.markPaidSingle.inv_pay_ref_no ? null : false
    },
    model: {
      value: (_vm.markPaidSingle.inv_pay_ref_no),
      callback: function($$v) {
        _vm.$set(_vm.markPaidSingle, "inv_pay_ref_no", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "markPaidSingle.inv_pay_ref_no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Amount",
      "label-for": "single-amt"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "single-amt",
      "type": "number",
      "step": "0.01",
      "min": "0",
      "placeholder": "Amount",
      "state": _vm.markPaidSingle.inv_pay_amt !== null && Number(_vm.markPaidSingle.inv_pay_amt) > 0 ? null : false
    },
    model: {
      value: (_vm.markPaidSingle.inv_pay_amt),
      callback: function($$v) {
        _vm.$set(_vm.markPaidSingle, "inv_pay_amt", _vm._n($$v))
      },
      expression: "markPaidSingle.inv_pay_amt"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Payment Date",
      "label-for": "single-date"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "single-date",
      "type": "date",
      "state": _vm.markPaidSingle.inv_pay_date ? null : false
    },
    model: {
      value: (_vm.markPaidSingle.inv_pay_date),
      callback: function($$v) {
        _vm.$set(_vm.markPaidSingle, "inv_pay_date", $$v)
      },
      expression: "markPaidSingle.inv_pay_date"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeSinglePaymentModal
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.isLoading || !_vm.isSinglePaymentValid
    },
    on: {
      "click": _vm.submitSinglePayment
    }
  }, [(_vm.isLoading) ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.isLoading ? 'Processing...' : 'Save Payment') + "\n            ")], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n    ")])], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66e77cd1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/payment/getPaymentList.vue
// module id = 2696
// module chunks = 0